import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import {FormBuilder, Validators, FormsModule, ReactiveFormsModule,FormControl, FormArray, AbstractControl, FormGroup} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatStepperModule} from '@angular/material/stepper';
import {MatButtonModule} from '@angular/material/button';
import { UserPrivilegeService } from 'src/app/services/user-privilege.service';
import { DatePipe } from '@angular/common';
import { Router ,ActivatedRoute} from '@angular/router';
import {SettingsService} from '../../../services/settings.service';
import { FlightService } from 'src/app/services/flight.service';
import { InsuranceService } from 'src/app/services/insurance.service';
import { City, Country, State, StaticdataService } from 'src/app/services/staticdata.service';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/internal/operators/map';
import { startWith } from 'rxjs/internal/operators/startWith';
import { CustomValidatorsService } from 'src/app/services/custom-validators.service';
import { UserprofileService } from 'src/app/services/userprofile.service';
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { DataService } from 'src/app/services/data.service';
import { Location } from '@angular/common';
import {CarrierCodeService} from '../../../services/carrier-code.service';
import {AirConfigService}  from 'src/app/services/air-config.service'
import { PageEvent } from '@angular/material/paginator';
import {ReportingConfigService} from 'src/app/services/reporting-config.service'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { UserService } from 'src/app/services/user.service';

import { DialogService } from 'src/app/util/dialog/dialog.service';
import { concat } from 'rxjs';
import * as moment from 'moment';
import {TripService} from 'src/app/services/trip.service'

@Component({
  selector: 'app-insurance-booking',
  templateUrl: './insurance-booking.component.html',
  styleUrls: ['./insurance-booking.component.css']
})
export class InsuranceBookingComponent {
  ngOnInit() {
    // Check if user just reloaded
    if (localStorage.getItem('reloadRedirect') === 'true') {
      localStorage.removeItem('reloadRedirect');
      // this.Router.navigate(['/author']);
      window.close()
    }
  }
  relations: string[] = [
    'Sister',
    'Spouse',
    'Father',
    'Mother',
    'Daughter',
    'Son',
    'Brother',
    'Legal Heir'
  ];
  days: number[] = Array.from({ length: 31 }, (_, i) => i + 1);
  months = [
  { value: '1', label: 'JAN' },
  { value: '2', label: 'FEB' },
  { value: '3', label: 'MAR' },
  { value: '4', label: 'APR' },
  { value: '5', label: 'MAY' },
  { value: '6', label: 'JUN' },
  { value: '7', label: 'JUL' },
  { value: '8', label: 'AUG' },
  { value: '9', label: 'SEP' },
  { value: '10', label: 'OCT' },
  { value: '11', label: 'NOV' },
  { value: '12', label: 'DEC' }
];
carrierCode = []

  fetchPassengerDetails:any
  years =Array.from({ length: 12 }, (_, i) => new Date().getFullYear() - i);
  infentsYears =Array.from({ length: 2 }, (_, i) => new Date().getFullYear() - i);
  @ViewChild('travellerInput') travellerInput!: ElementRef<HTMLInputElement>;
  traveller = new FormControl('');
  filteredTo!: Observable<any[]>;
  commercialFee:any
totalCommercialAmount:any=0
rules:any={
  InputPaxInfo:false
}
flightSeatMapping:any=[]

  separatorKeysCodesTo: number[] = [ENTER, COMMA];
  travellerTo:any=[]
  travellerName:any
  rows: string[] = ['A', 'B', 'C', 'D','E','F'];
  seats: number[]=[]
  // allSeats :any= Array.from({ length: 29 }, (_, index) => (index + 1).toString());
  allSeats :any=[];

  selectedSeats: string[]=[]
  usersList:any;
  repriceData:any=[]
  fare:any={
    totalPrice:0,
    totalTax:0
     }
  employeeData:any;
  userUid:any
  domIn:any={
    international:false,
    domestic:false
  }
  aisleSeats: string[] = [];
  flightList:any
  firstFormGroup = this._formBuilder.group({
    firstCtrl: ['first', Validators.required],
  });
  secondFormGroup = this._formBuilder.group({
    "passengerDetails":this.fb.array([
     
    ]),
    "passengerChild":this.fb.array([
     
    ]),
    "passengerInfent":this.fb.array([
      
    ]),
    "BillingEntity":['', Validators.required]
  });
  get passengerDetails(){
    return this.secondFormGroup.get('passengerDetails') as FormArray;
  }
  get passengerChild(){
    return this.secondFormGroup.get('passengerChild') as FormArray;
  }
  get passengerInfent(){
    return this.secondFormGroup.get('passengerInfent') as FormArray;
  }
  thirdFormGroup = this._formBuilder.group({
    mobileCtrl: ['', [Validators.required,Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
    emailCtrl: ['', [Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
    address: ['', [Validators.required]],
    state: ['', [Validators.required]],
    pincode: ['', [Validators.required,Validators.pattern("^[0-9]+$")]],
    city: ['', [Validators.required]],
    country: ['', [Validators.required]],


  });
  fourthFormGroup = this._formBuilder.group({
    fourthCtrl: ['', Validators.required],
  });
  isLinear = false;
flights:any
returnFlights:any
returnLastFlight:any
lastflight:any
thirdFlights:any
thirdLastFlight:any
fourthFlights:any
fourthLastFlight:any
userType:any
travellerDetail:any={}
addressCountryFormControl! : FormControl; 
pnrNo:any
userUuid:any
countryFilteredOptions: Observable<Country[]>|undefined;
seatPagination:any
dataMapping:any

flightSegments:any=[]
travelType:any='AD'
loginUserType:any
totalBreakup:any



  constructor(private UserService:UserService,private DialogService:DialogService,private location:Location,private order:DataService,private userInfoService : UserInfoService,private DataEntityService:ReportingConfigService,
    private _formBuilder: FormBuilder,private route:ActivatedRoute,private CarrierCodeService:CarrierCodeService,
    private  SettingsService:SettingsService,private FlightService:FlightService,public staticDataService : StaticdataService,
    private customValidator : CustomValidatorsService,private fb : FormBuilder,private userProfileService:UserprofileService,
    private AirConfigService:AirConfigService, private toastMsgService : ToastmsgService,private TripService:TripService,
    private userPrivileges:UserPrivilegeService,private InsuranceService:InsuranceService
    
    ) {

      
      this.ENABLE_TRIP_MGMT()
      this.userType=userInfoService.getUserType();
      this.userType=this.userType.toUpperCase()
      this.userUuid=this.userInfoService.getUserUuid()

      this.loginUserType=sessionStorage.getItem('loginUserType')
      this.loginUserType=this.loginUserType.toUpperCase()
      this.userPrivileges.userPrivilegesByModule('BookingUsers').then((privileges:any) => {
        this.privilegesValue(privileges)
      })
      .catch((error:any) => {
      console.error(error); // Handle errors, if any
      });
      this.dataEntitylist()
      
      if(this.userType==='AGENT'){
        // this.billingDetail?.entityName
        this.secondFormGroup.patchValue({
          BillingEntity: 'N/A'
        });
      }
      this.reportingTags()
        this.AirConfigService
        .getGeneralConfig(this.userUuid)
        .subscribe({
          next : (res:any) => {
            if(res) {
              let data=res
             this.domIn.international=data[0]?.internationalEnabled
             this.domIn.domestic=data[0]?.domesticEnabled
            

        
 
            } else {
            
            } 
          },error : (err) => {
    
          }
        }
      )



      this.carrierCode=this.CarrierCodeService.carrierCode()
      this.rulesPriv()
    

this.route.queryParams.subscribe(params => {
  let data:any
  data=params
if(data?.id){
this.orderId=this.SettingsService.decodeTransformed(data?.id)
}
this.swingGenerate=true

  this.InsuranceService
  .getInsuranceDatabyOrderID(this.orderId)
  .subscribe({
    next : (res:any) => {
     

      if(res) {
      
       let response:any
       response=res
       this.travelType=response?.airSearchRequest?.travelType||'AD'
       this.dataMapping=response
       this.seatPagination=response
       this.countryListByCategory()
       const totalBreakup = this.calculateTotalPriceBreakup(this.dataMapping?.insurancePlanSearchResponse?.persons);
this.totalBreakup=totalBreakup
     
      //  this.fetchPassengerDetails=response?.flightBooking[0]?.passengerDetails
      this.travellerDetail=response?.travellerDetails
      this.pnrNo=response?.pnr
  
      // this.getFlightList();

      // this.onItineraryClick()

  this.getrepriceData(response)



  //this.SettingsService.decodeTransformedEmail(data.flightDetails)
 
   
//console.log(lastFlight)



    this.addressCountryFormControl = new FormControl({countryCode:"",countryName : ""},[Validators.required,this.customValidator.countryValidator()]);

    this.countryFilteredOptions = this.addressCountryFormControl?.valueChanges
  .pipe(
    startWith({} as Country),
    map((country :Country) => country && typeof country === 'object' ? country.countryName : country),
    map((countryName: string) => countryName ? this._filterCountry(countryName) : this.staticDataService?.countryCache.slice())
  );
 
  
  for(let i=0;i<this.travellerDetail?.adult;i++){

  

    const reportingTagsGroup:any = this.fb.array([]);

    


    this.reportingData.forEach((tag: any) => {
      // show to traveller
      if(this.userType==='EMPLOYEE'){
        if (tag.tagValue['show to traveller'] === 'Y') {
          if(tag.tagValue['fieldType'] === 'D'){
            let invoiceboolean:boolean=false
            if(tag["print on invoice"]==='Y'){
              invoiceboolean=true
            }
                    const controlValidators = tag.required === 'C' ? [Validators.required] : [];
                    const controlName =  tag?.tagDisplayName||tag?.tagName;
                    const name=tag?.tagName
                    const value = tag.tagFixedValue && tag.tagFixedValue.includes(':') ? tag.tagFixedValue.split(':')[1] : tag.tagFixedValue;
            
                    const reportingTagGroup = this.fb.group({
                      displayName:[controlName],
                      name: [name],
                      value: ['', controlValidators],
                      invoiceable: [invoiceboolean],
                      required:tag.required,
                      checkValue:[value],
                      fieldType:tag.tagValue['fieldType']
                    });
                    reportingTagsGroup.push(reportingTagGroup);
  
  
          }else{
          let invoiceboolean:boolean=false
  if(tag["print on invoice"]==='Y'){
    invoiceboolean=true
  }
          const controlValidators = tag.required === 'C' ? [Validators.required] : [];
          const controlName =  tag?.tagDisplayName||tag?.tagName;
          const name=tag?.tagName
          const value = tag.tagFixedValue && tag.tagFixedValue.includes(':') ? tag.tagFixedValue.split(':')[1] : tag.tagFixedValue;
  
          const reportingTagGroup = this.fb.group({
            displayName:[controlName],
            name: [name],
            value: [tag?.tagFixedValue?.startsWith(':') ? '' : value, controlValidators],
            invoiceable: [invoiceboolean],
            required:tag.required,
            checkValue:[value],
            fieldType:tag.tagValue['fieldType']
          });
          reportingTagsGroup.push(reportingTagGroup)
        }}
      }else{
      if (tag.tagValue['show to admin'] === 'Y') {
        if(tag.tagValue['fieldType'] === 'D'){
          let invoiceboolean:boolean=false
          if(tag["print on invoice"]==='Y'){
            invoiceboolean=true
          }
                  const controlValidators = tag.required === 'C' ? [Validators.required] : [];
                  const controlName =  tag?.tagDisplayName||tag?.tagName;
                  const name=tag?.tagName
                  const value = tag.tagFixedValue && tag?.tagFixedValue?.includes(':') ? tag?.tagFixedValue.split(':')[1] : tag.tagFixedValue;
          
                  const reportingTagGroup = this.fb.group({
                    displayName:[controlName],
                    name: [name],
                    value: ['', controlValidators],
                    invoiceable: [invoiceboolean],
                    required:tag.required,
                    checkValue:[value],
                    fieldType:tag.tagValue['fieldType']
                  });
                  reportingTagsGroup.push(reportingTagGroup);


        }else{
        // console.log(tag)
        let invoiceboolean:boolean=false
if(tag["print on invoice"]==='Y'){
  invoiceboolean=true
}
        const controlValidators = tag.required === 'C' ? [Validators.required] : [];
        const controlName =  tag?.tagDisplayName||tag?.tagName;
        const name=tag?.tagName
        const value = tag.tagFixedValue && tag?.tagFixedValue?.includes(':') ? tag.tagFixedValue.split(':')[1] : tag.tagFixedValue;
        const reportingTagGroup = this.fb.group({
          displayName:[controlName],
          name: [name],
          value: [tag?.tagFixedValue?.startsWith(':') ? '' : value, controlValidators],
          invoiceable: [invoiceboolean],
          required:tag.required,
          checkValue:[value],
          fieldType:tag.tagValue['fieldType']
        });
        reportingTagsGroup.push(reportingTagGroup);
      }}}
    });
  
    

    this.passengerDetails.push(this.fb.group({
      "salutation": ['',[Validators.required]],
      "name":[''],
      "firstName":['',[Validators.required]],
      "lastName":['',[Validators.required]],
      "dob":[this.dataMapping?.insurancePlanSearchResponse?.persons[i]?.dobText,[Validators.required]],
      "gender": [''],
      "passportNo": ['',[Validators.required,Validators.pattern(/^[A-PR-WY][0-9]{6,8}$/)]],
      "nationality": [''],
      "visaType": [''],
      "emailId":["",[Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)],],
      "contactNo":["",[Validators.required,,Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
      "profileType":[''],
     "reportingTags":reportingTagsGroup,
      "maritalStatus":  ['',[Validators.required]],
      "employmentStatus":['',[Validators.required]],
      "panNo": [''],
      "aadharCard": [''],
      "alternateMobileNo": [''],
      "communicationAddress": this.fb.group( {
          "addressLine1": ['',[Validators.required]],
          "addressLine2": ['',],
          "addressLine3": [''],
          "cityDistrict": ['',[Validators.required]],
          "state":['',[Validators.required]],
          "country": ['',[Validators.required]],
          "pincode":['',[Validators.required]],
          "landmark": ['']
      }),
      "permanentAddress": this.fb.group( {
          "addressLine1": [''],
          "addressLine2": [''],
          "addressLine3": [''],
          "cityDistrict": [''],
          "state":[''],
          "country": [''],
          "pincode": [''],
          "landmark": ['']
      }),
      // "nominees": [
          
              "nomineeName": [''],
              "nomineeDob": [''],
              "nomineeSalutation": ['',[Validators.required]],
              // "name":['',[Validators.required]],
              "nomineeFirstName":['',[Validators.required]],
              "nomineeLastName":['',[Validators.required]],
              "nomineeRelationWithProposer": ['',[Validators.required]],
              "relationWithInsured": [''],
              "percentageOfShare": [''],
              "nomineeMobile": [''],
              "nomineeEmailId": [''],
              "appointeeName": [''],
              "guardianName": [''],
              "nomineeAddress":this.fb.group( {
                  "addressLine1": [''],
                  "addressLine2": [''],
                  "addressLine3": [''],
                  "cityDistrict": [''],
                  "state": [''],
                  "country": [''],
                  "pincode": [''],
                  "landmark":['']
              })
          
      
   }))
    
    // console.log(reportingTagsGroup.value)
    // this.passengerDetails.push(this.fb.group({
    //     "firstName":[''],
    //     "lastName":['',[Validators.required]],
    //     "dob":[''],
    //     "gender":['',[Validators.required]],
    //     "profileType":[''],
    //     "passengerTitle":['',[Validators.required]],
    //     "passengerType":["ADT",[Validators.required]],
    //     "username":[""],
    //      "email":["",[Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)],],
    //      "mobile":["",[Validators.required,,Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
    //     "reportingTags":reportingTagsGroup,
    //     "frequentFlier":[''],
    //     "userPassportDetails":this.fb.group({
    //       "passportNumber": [''],
    //       "passportDOB": [''],
    //       "passportDOI": [''],
    //       "passportDOE": [''],
    //       "passportPOI": [''],
    //       "passportCountry": ['']
    //   }),
    //   "userVisaDetails":this.fb.group({
    //       "name": [''],
    //       "visaNumber": [''],
    //       "issuingCountry": [''],
    //       "type": [''],
    //       "issueDate":[''],
    //       "expiryDate":['']
    //   })

    // }))

  }
 
 
  
         


         let traveller=(Number(this.travellerDetail?.adult))
         if(traveller>1){
          this.travellerS="travellers"
   
         }else{
          this.travellerS="traveller"   
         }

        //  this.getrepriceData(response);

        this.swingGenerate=false

        
        
        } else {    
          if(this.userType!='STAFF'){
          this.DialogService.open({msg : "Failed to process data!",title : "Confirmation",buttonType : "tag"})
             
          this.DialogService.onResponse((response :  string) => {
           
            if(response=="Back to Search Page") {
              window.close();
  
  
            }})
          }
        } 



        },error : (err) => {
                  if(this.userType!='STAFF'){

            this.DialogService.open({msg : "Failed to process data!",title : "Error",buttonType : "tag"})
             
              this.DialogService.onResponse((response :  string) => {
               
                if(response=="Back to Search Page") {
                  window.close();
      
      
                }})}
          
        
        }
        }
        )
            });
  }
  privilegesView:any
  privilegesValue(privs:any){
   
    let privileges="";
  
  if(privs.includes('view')){
    this.privilegesView="VAMD"
  }else{
    this.privilegesView="AccessDenied"
  }
  
  }
  travellerS:any
  getReportingTagsControls(passenger: AbstractControl): AbstractControl[] {
    const reportingTags = passenger.get('reportingTags') as FormArray;
// console.log(reportingTags)
    return reportingTags ? reportingTags.controls : [];
  }

  onItineraryClick(){
    this.firstFormGroup = this.fb.group({
      firstCtrl: ['first', Validators.required],
    });
    if(this.userType==='CORPORATE'||this.userType==='AGENT'){
      this.getCorporateUsers();
      this.onfilterChange(this.fetchPassengerDetails)
    }else if(this.userType==='EMPLOYEE'){
      
       if(this.tripEnable){
      this.getActiveTripList()
    }else{
       if(this.privilegesView==='VAMD'){
        this.getCorporateUsers();

       }else{
        this.getEmployeeData();
       }
      }
    }
    
  }
  _filterCountry(countryName: string): Country[] {
    return this.staticDataService.countryCache.filter(option =>
      option.countryName.toLowerCase().indexOf(countryName.toLowerCase()) === 0);
  }
  displayCountrySelectionFn(country : Country) {
    return country ? country.countryName : "";
  }
  dateFormate(date:any){
    // date=this.convertToISOStringFormat(date)
    const parsedDate = new Date(date);
    const datePipe = new DatePipe('en-IN');
    date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
    // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');

return date

  }

  convertToISOStringFormat(dateString:any) {
    // Remove the ' 00:00' part and then add 'Z' at the end
    const isoDateString = dateString.replace('00.000 00:00', '00.000Z');
    return isoDateString;
  }
timeFormate(date:any){
    // date=this.convertToISOStringFormat(date)
    const parsedDate = new Date(date);
    const datePipe = new DatePipe('en-IN');
    date = datePipe.transform(parsedDate, 'HH:mm'); 
    // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');

return date

  }
  isSeatSelected(row: string, seat: number): boolean {
    
    return this.selectedSeats.includes(row + seat);
  }

  isAisle(row: string, seat: number): boolean {
    
    return this.aisleSeats.includes(row + seat);
  }

  
  toggleSeat(row: string, seat: number): void {

    const seatIdentifier = row + seat;
  

    if (this.selectedSeats.includes(seatIdentifier)) {
      this.selectedSeats = this.selectedSeats.filter(
        (selectedSeat) => selectedSeat !== seatIdentifier

        
      );
   
     
    } else {
      if (this.selectedSeats.length <this.flightMealDetails.length) {
        this.selectedSeats.push(seatIdentifier);
       
for (let i = 0; i < this.flightMealDetails.length; i++) {
  // Directly access the flightDetailsList for readability
  let flightDetailsList = this.flightMealDetails[i].flight.flightDetailsList;
  // Find the first item that matches the fromAirport condition
  
  let itemToUpdate = flightDetailsList.find((item:any) => item.fromAirport === this.flightSeatMapping.fromAirport&&item.toAirport === this.flightSeatMapping.toAirport);
if(itemToUpdate===undefined){
   flightDetailsList = this.flightMealDetails[i].returnFlights.flightDetailsList;

  itemToUpdate = flightDetailsList.find((item:any) => item.fromAirport === this.flightSeatMapping.fromAirport&&item.toAirport === this.flightSeatMapping.toAirport);

  if(itemToUpdate===undefined){
    flightDetailsList = this.flightMealDetails[i].thirdFlights.flightDetailsList;
 
   itemToUpdate = flightDetailsList.find((item:any) => item.fromAirport === this.flightSeatMapping.fromAirport&&item.toAirport === this.flightSeatMapping.toAirport);

   if(itemToUpdate===undefined){
    flightDetailsList = this.flightMealDetails[i].fourthFlights.flightDetailsList;
 
   itemToUpdate = flightDetailsList.find((item:any) => item.fromAirport === this.flightSeatMapping.fromAirport&&item.toAirport === this.flightSeatMapping.toAirport);
 }
 }


}

  // If an item is found and there's a corresponding selectedSeat, update the seat
  if (itemToUpdate && this.selectedSeats[i]) {
    itemToUpdate.seatPrice=this.SeatPrice(this.selectedSeats[i])
    // console.log(itemToUpdate)
    // console.log(this.selectedSeats[i])
    itemToUpdate.seat = this.selectedSeats[i];
    if(this.unitKeyData.length>0){
      if(this.unitKeyData[0].unitKey){

    itemToUpdate.unitKey = this.unitKeyData.filter((key:any)=>key.seat===itemToUpdate.seat)[0].unitKey}
  }
  }

  
}


        
              
      

        
      } else {
        // Handle the case where the user tries to select more than three seats
        // console.log("You can only select up to "+this.flightMealDetails.length+" seats.");
      }
      // this.selectedSeats.push(seatIdentifier);
    }
this.fourthFormGroup = this._formBuilder.group({
  fourthCtrl: [this.selectedSeats.toString(), Validators.required],
});
this.mealSeatPriceTotal()
  }

  SeatPrice(columnrow:any){
    let price:any=0
    if(this.seatFare.length>0){
    this.seatFare.forEach((item:any):any=>{
  
      if(item.seat==columnrow){
        // console.log(item.price)
   price= item.price||0
      }
  
  
    })}
    // console.log(price)
      return price
  }


  isrequired(row: string, seat: number): boolean {
    
    return this.selectedSeats.includes(row + seat);
  }
  
  converter(item:any){
    const totalMinutes = item ;
    const hours = Math.floor(totalMinutes / 60);
    const remainingMinutes = totalMinutes % 60;
    item=`${hours}h ${remainingMinutes}m`
    return item
  }
  fligthNameFilter(item:any){
  if(item){
  let flightName:any=[]
  flightName=this.carrierCode.filter((itm: { carrierCode: any; })=>itm.carrierCode === item)
  if(flightName.length===0){
   return item
 
 }else{
   flightName =flightName[0].flightName
   return flightName
 }}else{
  return item
 }
  }
  cityFilter(item:any){
    

    if(item && this.flightList){
     
  
      item=this.flightList.filter((itm: { iataCode: any; })=>itm.iataCode === item)
  
    item=item[0]?.city
  
  return item}else{
    return item
  }
  }
  airPortFilter(item:any){
    
    if(item && this.flightList){
    item=this.flightList.filter((itm: { iataCode: any; })=>itm.iataCode === item)
  
  item=item[0]?.name
  return item}else{
    return item
  }
  }
 
  getFlightList(){
   
    this.FlightService
    .getFlightList()
    .subscribe({
      next : (res:any) => {
        if(res) {
         let data:any
         data=res  
         this.flightList=data
     
        } else {    
        } 
      },error : (err) => {

        
      }
    }
  )
  }
  flightMealDetails:any
  travellerDetails:any=[]
  RequiredPopup(){
    
if(this.passengerDetails.invalid||this.passengerChild.invalid||this.passengerInfent.invalid||!this.secondFormGroup.value.BillingEntity){
  let adultData:any=this.getInvalidFields(this.passengerDetails)
  let childData:any=this.getInvalidFields(this.passengerChild)
  let infData:any=this.getInvalidFields(this.passengerInfent)

let adult:any = adultData.map((item:any) => `Adult ${item.passengerIndex + 1}: ${item.invalidFields.join(', ')}`).join('\n')
let child:any =childData.map((item:any) => `Child ${item.passengerIndex + 1}: ${item.invalidFields.join(', ')}`).join('\n')
let inf:any =infData.map((item:any) => `Infent ${item.passengerIndex + 1}: ${item.invalidFields.join(', ')}`).join('\n')
let billingEntity=''
// console.log(this.secondFormGroup.value.BillingEntity)
if(this.secondFormGroup.value.BillingEntity){
  billingEntity=''
}else{
  billingEntity='billingEntity'

}
let allData = [adult, child,inf, billingEntity].filter(Boolean).join('\n');

    this.DialogService.open({msg :allData,title : "Warning (Required Fields is missing)",buttonType : "Ok"})
       
    this.DialogService.onResponse((response :  string) => {
     
      if(response=="Ok") {


      }})}

  }
  getInvalidFields(item:any) {
    return item.controls.map((group:any, index:any) => {
      const invalidFields = Object.keys((group as FormGroup).controls)
        .filter(field => (group as FormGroup).get(field)?.invalid);
      
      return invalidFields.length > 0 ? { passengerIndex: index, invalidFields } : null;
    }).filter((entry:any) => entry !== null);
  }
  PassengerDetails(){
  //  console.log(this.secondFormGroup.value)
  
   let  merged_passengerDetails:any=[]
  //  merged_passengerDetails=merged_passengerDetails.concat(this.secondFormGroup.value.passengerDetails)
   merged_passengerDetails=this.secondFormGroup.value.passengerDetails


  //  console.log(this.travellerDetails)
  let travellerDetail:any=[]
  //  this.travellerDetails?.forEach((item:any)=>{
    
  //   item.username=item.email
  //   item.name=item?.firstName+' '+item?.lastName

  //   item.nominees=[

      
  //   ]
  //   item.nomineeName=item?.nomineeFirstName+' '+item?.nomineeLastName
  //  })


   const result = this.mapData(merged_passengerDetails);
   this.travellerDetails=result
  //  console.log(result)
  }

  mapData(data: any[]): any[] {

   

    return data.map((item) => {
      const nominee = {
        nomineeName: item.nomineeName || `${item.nomineeFirstName} ${item.nomineeLastName}`.trim(),
        nomineeDob: item.nomineeDob || '',
        nomineeRelationWithProposer: item.nomineeRelationWithProposer || '',
        relationWithInsured: item.relationWithInsured || '',
        percentageOfShare: item.percentageOfShare || '',
        nomineeMobile: item.nomineeMobile || '',
        nomineeEmailId: item.nomineeEmailId || '',
        appointeeName: item.appointeeName || '',
        guardianName: item.guardianName || '',
        nomineeAddress: item.communicationAddress
      };
  
      return {
        salutation: item.salutation, // Add logic for other salutations if needed
        name: `${item.firstName} ${item.lastName}`.trim(),
        firstName: item.firstName,
        lastName: item.lastName,
        dob: item.dob,
        gender: item.gender,
        passportNo: item.passportNo,
        nationality: item.nationality || '',
        visaType: item.visaType || '',
        contactNo: item.contactNo,
        emailId: item.emailId,
        maritalStatus: item.maritalStatus,
        panNo: item.panNo,
        aadharCard: item.aadharCard,
        alternateMobileNo: item.alternateMobileNo,
        "communicationAddress": { ...item.communicationAddress },
        permanentAddress: { ...item.communicationAddress },
        nominees: [nominee],
        reportingTags: item.reportingTags || []

      };
    });
  }
 
paymentDetail:boolean=false
backClick(){
  this.paymentDetail=false



}

getActiveTripList(){
  this.TripService
  .getActiveTrip( this.userUuid)
  .subscribe({
    next : (res:any) => {
      if(res) {
        let data:any = res
        // this.tripResponse={
        //   tripName:data?.tripName,
        //   tripUid:data?.tripUid,
        //   status:data?.status,
        //   approvalLevel1Email:data?.approvalLevel1Email,
        //   statusDesc:data?.statusDesc
        // }
        if(data.tripDetails&&data.tripDetails.onBehalf.length!=0){
          // this.rules.InputPaxInfo=false
        this.getCorporateUsersList(data.tripDetails.onBehalf)
        }else if(data.tripDetails&&data.tripDetails.otherList.length!=0){
        this.getGuestList(data.tripDetails.otherList)

        } else{
          this.getEmployeeData();
        }
      
       } else {
        this.getEmployeeData();

       } 
    },error : (err) => {
      this.getEmployeeData();

      console.error("Error in fetching result");
    }
  })}


  getGuestList(data:any){
    let adult:any=data.filter((item:any)=>item.passengerType==='ADT')
    let child:any=data.filter((item:any)=>item.passengerType==='CHD')
    let inf:any=data.filter((item:any)=>item.passengerType==='INF')

for(let i=0 ;i< adult.length ;i++){
      this.passengerDetails.controls[i].value.firstName=adult[i]?.firstName
      this.passengerDetails.controls[i].value.lastName=adult[i]?.lastName
      this.passengerDetails.controls[i].value.email=adult[i]?.email
      this.passengerDetails.controls[i].value.mobile=adult[i]?.mobile
      this.passengerDetails.controls[i].value.passengerTitle=adult[i]?.title
      this.passengerDetails.controls[i].value.username=adult[i]?.email
      this.passengerDetails.setValue(this.passengerDetails.value);
}
for(let i=0 ;i< child.length ;i++){
  this.passengerChild.controls[i].value.firstName=child[i]?.firstName
  this.passengerChild.controls[i].value.lastName=child[i]?.lastName
  this.passengerChild.controls[i].value.email=child[i]?.email
  this.passengerChild.controls[i].value.mobile=child[i]?.mobile
  this.passengerChild.controls[i].value.passengerTitle=child[i]?.title
  this.passengerChild.setValue(this.passengerChild.value);
}
for(let i=0 ;i< inf.length ;i++){
  this.passengerInfent.controls[i].value.firstName=inf[i]?.firstName
  this.passengerInfent.controls[i].value.lastName=inf[i]?.lastName
  this.passengerInfent.controls[i].value.email=inf[i]?.email
  this.passengerInfent.controls[i].value.mobile=inf[i]?.mobile
  this.passengerInfent.controls[i].value.passengerTitle=inf[i]?.title
  this.passengerInfent.setValue(this.passengerInfent.value);
}

      this.thirdFormGroup =this.fb.group({
       mobileCtrl: [adult[0]?.contactNumber, [Validators.required,Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
       emailCtrl: [adult[0]?.username, [Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
       address: [adult[0]?.street, [Validators.required]],
       state: [adult[0]?.state, [Validators.required]],
       pincode: [adult[0]?.pincode, [Validators.required,Validators.pattern("^[0-9]+$")]],
       city: [adult[0]?.city, [Validators.required]],
       country: [adult[0]?.country, [Validators.required]],
     });
  }
getCorporateUsersList(onBehalf:any){
   
  this.userProfileService
  .getCorporateUserList()
  .subscribe({
    next : (res:any) => {
      if(res) {
       
       let data:any
       data=res  
     

data=data.filter((item:any) =>onBehalf.includes(item.userUid));
console.log(data)
for(let i=0 ;i< data.length ;i++){
console.log(data[i]?.userBookingProfile)
      this.passengerDetails.controls[i].value.firstName=data[i]?.userBookingProfile?.firstName

      this.passengerDetails.controls[i].value.lastName=data[i]?.userBookingProfile?.lastName
      this.passengerDetails.controls[i].value.dob=moment(data[i]?.userBookingProfile?.dob).toISOString()||''
      this.passengerDetails.controls[i].value.gender=data[i]?.userBookingProfile?.gender||''

      this.passengerDetails.controls[i].value.email=data[i]?.userBookingProfile?.username
      this.passengerDetails.controls[i].value.mobile=data[i]?.contactNumber
      this.passengerDetails.controls[i].value.profileType=data[i]?.userBookingProfile?.profileType

      this.passengerDetails.controls[i].value.passengerTitle=data[i]?.userBookingProfile?.title
      this.passengerDetails.controls[i].value.username=data[i]?.userBookingProfile?.username
      if(this.travelType==='AI'){
  
        let passportData=data[i]?.userBookingProfile?.passportDetails.length > 0 ? data[i]?.userBookingProfile?.passportDetails[data[i]?.userBookingProfile?.passportDetails.length - 1] : null;
        let visaData=data[i]?.userBookingProfile?.visaDetails.length > 0 ? data[i]?.userBookingProfile?.visaDetails[data[i]?.userBookingProfile?.visaDetails.length - 1] : null;
        // console.log(passengerDetails.value.userPassportDetails)
        this.passengerDetails.controls[i].value.userPassportDetails.passportNumber=passportData?.passportNumber
        this.passengerDetails.controls[i].value.userPassportDetails.passportDOB=passportData?.passportDOB
        this.passengerDetails.controls[i].value.userPassportDetails.passportDOI=passportData?.passportDOI
        this.passengerDetails.controls[i].value.userPassportDetails.passportDOE=passportData?.passportDOE
        this.passengerDetails.controls[i].value.userPassportDetails.passportPOI=passportData?.passportPOI
        this.passengerDetails.controls[i].value.userPassportDetails.passportCountry=passportData?.passportCountry
        // console.log(passportData?.passportCountry)
        // VISA 
        this.passengerDetails.controls[i].value.userVisaDetails.name=visaData?.name
        this.passengerDetails.controls[i].value.userVisaDetails.visaNumber=visaData?.visaNumber
        this.passengerDetails.controls[i].value.userVisaDetails.issuingCountry=visaData?.issuingCountry
        this.passengerDetails.controls[i].value.userVisaDetails.type=visaData?.type
        this.passengerDetails.controls[i].value.userVisaDetails.issueDate=visaData?.issueDate
        this.passengerDetails.controls[i].value.userVisaDetails.expiryDate=visaData?.expiryDate
        }
      this.passengerDetails.controls[i].value.reportingTags.forEach((item:any)=>{

        // console.log(data[i].userBookingProfile[item.checkValue])
if(item.checkValue){
        if(data[i].hasOwnProperty(item.checkValue)!=null){

          item.value=data[i].userBookingProfile[item.checkValue] ?? ''
        }}
    
        
      })
for(let i=0;i<this.passengerDetails.value.length;i++){

this.passengerDetails.controls[i].value.username=data[i]?.userBookingProfile?.username

}

      this.passengerDetails.setValue(this.passengerDetails.value);



}
// this.userUid=data[0]?.userUid

      this.thirdFormGroup =this.fb.group({
       mobileCtrl: [data[0]?.contactNumber, [Validators.required,Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
       emailCtrl: [data[0]?.userBookingProfile?.username, [Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
       address: [data[0]?.street, [Validators.required]],
       state: [data[0]?.state, [Validators.required]],
       pincode: [data[0]?.pincode, [Validators.required,Validators.pattern("^[0-9]+$")]],
       city: [data[0]?.city, [Validators.required]],
       country: [data[0]?.country, [Validators.required]],
     });
     if(data[0]?.billingEntity){
       let entityData:any
       entityData=this.DataEntity.filter((entity:any)=>entity.entityRefId===data[0].userBookingProfile?.billingEntity)
       this.addBillingEntity(entityData[0]) 
     }else{

       if(this.DataEntity.length===1){
         this.addBillingEntity(this.DataEntity[0]) 

       }
     }

      // this.filterTraveller()
      //  this.travellerTo=this.usersList
      //  this.filteredTo = this.traveller.valueChanges.pipe(
      //   // debounceTime(300), // Adjust the debounce time as needed
      //   //distinctUntilChanged(),
      //   startWith(null),
      //   map((item: any | null) => (item ? this._filter(item) : this.travellerTo.slice())),
      // );

      } else {    
      } 
    },error : (err) => {

      
    }
  }
)
}

listOfDestination:any=[]
  bookflight(){
//     this.advancedPricingDataList.forEach((item:any)=>{
//       item.advancedPricingList=item.advancedPricingList.filter((item:any) => item !== null)
//     })
// this.advancedPricingDataList=this.advancedPricingDataList.filter((item:any)=>item.advancedPricingList.length!==0)


   

     
   let data:any={}
//    let nomineeAddress:any={
//     "addressLine1": this.thirdFormGroup?.value?.address,
//     "addressLine2": '',
//     "addressLine3": '',
//     "cityDistrict": this.thirdFormGroup?.value?.city,
//     "state": this.thirdFormGroup?.value?.state,
//     "country": this.thirdFormGroup?.value?.country,
//     "pincode": this.thirdFormGroup?.value?.pincode,
//     "landmark":''
// }
// let communicationAddress: any= {
//   "addressLine1": this.thirdFormGroup?.value?.address,
//   "addressLine2": '',
//   "addressLine3": '',
//   "cityDistrict": this.thirdFormGroup?.value?.city,
//   "state":this.thirdFormGroup?.value?.state,
//   "country": this.thirdFormGroup?.value?.country,
//   "pincode":this.thirdFormGroup?.value?.pincode,
//   "landmark": ''
// }
// let permanentAddress:any= {
//   "addressLine1": this.thirdFormGroup?.value?.address,
//   "addressLine2": '',
//   "addressLine3": '',
//   "cityDistrict": this.thirdFormGroup?.value?.city,
//   "state":this.thirdFormGroup?.value?.state,
//   "country": this.thirdFormGroup?.value?.country,
//   "pincode": this.thirdFormGroup?.value?.pincode,
//   "landmark": ''
// }
    //  for(let pass of this.travellerDetails){
    //   pass.permanentAddress=permanentAddress
    //   pass.communicationAddress=communicationAddress
    //   pass.nominees[0].nomineeAddress=nomineeAddress
    //  }

 
  data={
    // "segment":this.flightSegments||[],

    "paxCount": this.travellerDetail?.adult,
    "adultCount": this.travellerDetail?.adult,
    "childCount": this.travellerDetail?.child,
    "infantCount": this.travellerDetail?.infantCount,
   
    "contactNumber": this.thirdFormGroup?.value?.mobileCtrl,
    "email":this.thirdFormGroup?.value?.emailCtrl,
    "address": this.thirdFormGroup?.value?.address,
    "state":this.thirdFormGroup?.value?.state,
    "pincode": this.thirdFormGroup?.value?.pincode,
    "city":  this.thirdFormGroup?.value?.city,
    "country": this.thirdFormGroup?.value?.country,
    "isInternational":  this.domIn.international,
    "isDomestic":this.domIn.domestic,
    "bookedFor":this.userUid,
      'gstNumber':   this.billingDetail?.entityGST    ,
      'billingEntity':   this.billingDetail.entityRefId  ,
       'gstEmail':   this.billingDetail?.email   ,
       'insuranceProposalRequest':{
        "persons": this.travellerDetails,
        'runtimeMarkUp':this.advancedPricingDataList,
       'planName':this.dataMapping?.insurancePlanSearchResponse?.planName,
     'tripStartDate':this.dataMapping?.insuranceRequest?.tripStartDate,
     'tripEndDate':this.dataMapping?.insuranceRequest?.tripEndDate,
      'numberOfPerson':this.dataMapping?.travellerDetails.adult,
      'listOfDestination':this.listOfDestination?.join(',')||'',

       }
  
  }



this.swingOrderId=true
// sessionStorage.setItem('json', JSON.stringify(data));
// sessionStorage.setItem('advancetotal',this.advanceTotal.toString());
// sessionStorage.setItem('totalSeatPrice', this.totalSeatPrice.toString());
// sessionStorage.setItem('totalMealPrice', this.totalMealPrice.toString());

// sessionStorage.setItem('totalspecialSsrPrice', this.totalspecialSsrPrice.toString());
// sessionStorage.setItem('totalssrBaggagePrice', this.totalssrBaggagePrice.toString());


this.OrderId(data)
//this.bookingData(data)
  }

  restrictedSeats:any=[]
  chargeableSeats:any=[]
  seatFare:any=[]
  unitKeyData:any=[]
seatMapping(data:any,flightDetailsList:any){
  this.unitKeyData=[]
  this.chargeableSeats=[]
  this.restrictedSeats=[]
  this.aisleSeats=[]
  this.seatFare=[]
  this.seats=[]
// console.log(flightDetailsList)

// this.flightItem
  this.FlightService
  .SeatMapping(data,this.orderId,this.flightMealDetails)
  .subscribe({
    next : (res:any) => {
      flightDetailsList.showSeatSelection=false

      if(res) {
        
        let data:any
        data=res
        if(data.errorDetails){
          this.toastMsgService.setMsg({msg : data?.errorDetails?.errorData?.errorMessage
            ,msgTitle : "Error", msgType : "E"});
          }else{
        data.airSeatRows.sort((a:any, b:any) => {
          return a.row - b.row; // Sort in ascending order based on 'row' property
        });


      data.airSeatRows.forEach((row:any)=>{
        this.seats.push(row.row)

        row.airSeats.forEach((column:any)=>{
          if(column.seatCharacteristics){

            let CHARGEABLE_SEAT:any='CHARGEABLE_SEAT'
            let RESTRICTED_SEAT:any='RESTRICTED_SEAT'
            

            if(column.seatCharacteristics.includes(CHARGEABLE_SEAT)){
              // console.log(column.column)
              if(column?.seatOccupancy!='Occupied'){
            this.chargeableSeats.push(column.column+row.row)
              }
            }
            if(column.seatCharacteristics.includes(RESTRICTED_SEAT)){
              this.restrictedSeats.push(column.column+row.row)
            }
          }
          // if(column.seatCharacteristics){
          //   // console.log(column.column+row.row)
          //   column.seatCharacteristics.forEach((item:any)=>{

          //     if(item.includes('CHARGEABLE_SEAT')){ 
          //       this.chargeableSeats.push(column.column+row.row)

          //                     }
                             
          //                    if(item.includes('RESTRICTED_SEAT')){

          //                     this.restrictedSeats.push(column.column+row.row)
            
          //                                  }
              
          //   })
          //       }

          if(column?.seatOccupancy==='Occupied'){
            this.aisleSeats.push(column.column+row.row)
          }
          if(column?.seatOccupancy==='Available'){
            this.seatFare.push({seat:column.column+row.row,price:column?.baseFare})

            // this.seatFare.push({seat:column.column+row.row,price:column?.baseFare+column?.finalTax})
          }

          

            if(column.unitKey){
         this.unitKeyData.push({seat:column.column+row.row,unitKey:column.unitKey})
          }
          

})
        
      })
    
if(this.seats.length!=0){
  this.seatPopup=true

}else{
 
  // this.seatPopup=true

  // this.seats=this.allSeats.slice(0, 29);
}
}
      } else {    
        // this.seatPopup=true

  // this.seats=this.allSeats.slice(0, 29);
      } 
    },error : (err) => {
      // this.seatPopup=true
      this.toastMsgService.setMsg({msg : "Seats is not available",msgTitle : "Warning", msgType : "W"});

      // this.seats=this.allSeats.slice(0, 29);
      flightDetailsList.showSeatSelection=false

    }
  }
)

}


isRestricted(column:any,row:any){
  let boolean:boolean=false

  if(this.restrictedSeats.length>0){
    this.restrictedSeats.forEach((item:any):any=>{

      if(item==column+row){
        boolean=true

      }})
  
}

return boolean

}
isChargeable(column:any,row:any){
  let boolean:boolean=false

  if(this.chargeableSeats.length>0){
    this.chargeableSeats.forEach((item:any):any=>{

      if(item==column+row){
        boolean=true

      }})
}

return boolean

}

popoverSeatPrice(column:any,row:any){
  let price:any='N/A'
  if(this.seatFare.length>0){
  this.seatFare.forEach((item:any):any=>{

    if(item.seat==column+row){
      // console.log(item.price)
 price= item.price+' INR'||0
    }


  })}
  // console.log(price)
    return price
}

  getCorporateUsers(){
   
    this.userProfileService
    .getUserList()
    .subscribe({
      next : (res:any) => {
        if(res) {
         
         let data:any
         data=res  
         this.usersList=data
        this.usersList=this.usersList.filter((item:any) => item.firstName && item.firstName.trim() !== '');
         this.travellerTo=this.usersList
         this.filteredTo = this.traveller.valueChanges.pipe(
          // debounceTime(300), // Adjust the debounce time as needed
          //distinctUntilChanged(),
          startWith(null),
          map((item: any | null) => (item ? this._filter(item) : this.travellerTo.slice())),
        );
        if(this.privilegesView==='VAMD'){
          if(this.employeeData?.billingEntity){
            let entityData:any
            entityData=this.DataEntity.filter((entity:any)=>entity.entityRefId===this.employeeData.billingEntity)
            this.addBillingEntity(entityData[0]) 
          }else{
            if(this.DataEntity.length===1){
              this.addBillingEntity(this.DataEntity[0]) 
  
            }}}
        } else {    
        } 
      },error : (err) => {

        
      }
    }
  )
  }
  onfilterChange(passengerDetails:any){

    for(let i=0;i<passengerDetails?.length;i++){
      
    let data:any
    if(passengerDetails[i].username){
    data=this.travellerTo?.filter((item:any) =>{item.username===passengerDetails[i]?.username})
    this.passengerDetails.controls[i].value.firstName=data[0]?.firstName
    // this.passengerDetails.controls[i].value.dob=moment(data[0]?.dob).toISOString()||'' 
    //this.passengerDetails.controls[i].value.dob=data[0]?.dob||''
    this.passengerDetails.controls[i].value.gender=data[0]?.gender||''

    this.passengerDetails.controls[i].value.lastName=data[0]?.lastName
        this.passengerDetails.controls[i].value.profileType=data[0]?.profileType

    this.passengerDetails.controls[i].value.salutation=data[0]?.title
    passengerDetails.value.emailId=data[0]?.username
    passengerDetails.value.contactNo=data[0]?.contactNumber
    if( this.passengerDetails.controls[i].value.lastName){
this.passengerDetails.setValue(this.passengerDetails.value);
    }
    let passportData=data[0]?.passportDetails.length > 0 ? data[0]?.passportDetails[data[0]?.passportDetails.length - 1] : null;
    // let visaData=this.employeeData?.visaDetails.length > 0 ? this.employeeData?.visaDetails[this.employeeData?.visaDetails.length - 1] : null;
    // console.log(passengerDetails.value.userPassportDetails)
    if(passportData){

    this.passengerDetails.controls[0].value.userPassportDetails.passportNo=passportData?.passportNumber
  }
    this.thirdFormGroup =this.fb.group({
      mobileCtrl: [data[0]?.contactNumber, [Validators.required,Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
      emailCtrl: [data[0]?.username, [Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
      address: [data[0]?.street, [Validators.required]],
      state: [data[0]?.state, [Validators.required]],
      pincode: [data[0]?.pincode, [Validators.required,Validators.pattern("^[0-9]+$")]],
      city: [data[0]?.city, [Validators.required]],
      country: [data[0]?.country, [Validators.required]],
    });

  }}
  }
  onfilterClick(value:any,passengerDetails:any){

    this.travellerInput.nativeElement.value=''

   for(let i=0;i<3;i++){     
    let data:any
    data=this.travellerTo.filter((item:any) => item.username===value)
    // console.log(moment(data[0]?.dob).toISOString());
    passengerDetails.value.firstName=data[0]?.firstName
    passengerDetails.value.lastName=data[0]?.lastName
    passengerDetails.value.salutation=data[0]?.title
    passengerDetails.value.profileType=data[0]?.profileType
    passengerDetails.value.communicationAddress.addressLine1=data[0]?.address
    passengerDetails.value.communicationAddress.state=data[0]?.state
    passengerDetails.value.communicationAddress.pincode=data[0]?.pincode
    passengerDetails.value.communicationAddress.cityDistrict=data[0]?.city
    passengerDetails.value.communicationAddress.country=data[0]?.country

    
    //passengerDetails.value.dob=data[0]?.dob||''
    // passengerDetails.value.dob=moment(data[0]?.dob).toISOString()||''
    passengerDetails.value.gender=data[0]?.gender||""

    passengerDetails.value.emailId=data[0].username
    passengerDetails.value.contactNo=data[0].contactNumber
    let passportData=data[0]?.passportDetails.length > 0 ? data[0]?.passportDetails[data[0]?.passportDetails.length - 1] : null;
    // let visaData=this.employeeData?.visaDetails.length > 0 ? this.employeeData?.visaDetails[this.employeeData?.visaDetails.length - 1] : null;
    // console.log(passengerDetails.value.userPassportDetails)
    if(passportData){

      passengerDetails.value.passportNo=passportData?.passportNumber
  }
// if(passengerDetails.value.reportingTags.value.tagDisplayName.split().join().includes(':')){
  // console.log(passengerDetails.value.reportingTags)
  // console.log(passengerDetails.value.reportingTags)
// Passport

  passengerDetails.value.reportingTags.forEach((item:any)=>{

    // console.log(item)
    if(item.checkValue){
    if(data[0].hasOwnProperty(item.checkValue)!=null){
      item.value=data[0][item.checkValue]  ?? ''
}

    }
  })

  
  //  this.passengerDetails.controls[0].value.firstName=data[0]?.firstName

  //   this.passengerDetails.controls[0].value.lastName=data[0]?.lastName
  //   this.passengerDetails.controls[0].value.passengerTitle=data[0]?.title
    this.thirdFormGroup.value.emailCtrl=data[0].username
    this.userUid=data[0].userUid
    this.thirdFormGroup =this.fb.group({
      mobileCtrl: [data[0].contactNumber, [Validators.required,Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
      emailCtrl: [data[0].username, [Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
      address: [data[0]?.street, [Validators.required]],
      state: [data[0]?.state, [Validators.required]],
      pincode: [data[0]?.pincode, [Validators.required,Validators.pattern("^[0-9]+$")]],
      city: [data[0]?.city, [Validators.required]],
      country: [data[0]?.country, [Validators.required]],
    });
    // console.log(this.passengerDetails.value)
        this.passengerDetails.setValue(this.passengerDetails.value);

   }
   }

  selectedTo(event: MatAutocompleteSelectedEvent): void {

    this.travellerName=event.option.viewValue;

    this.travellerInput.nativeElement.value = event.option.viewValue;
  
    
     
    this.traveller.setValue(null);
  
  }
  getEmployeeData(){

    this.userProfileService
    .getEmployeeUser()
    .subscribe({
      next : (res:any) => {
        if(res) {

         let data:any
         data=res  
         this.employeeData=data
         this.passengerDetails.controls[0].value.firstName=this.employeeData?.firstName

         this.passengerDetails.controls[0].value.lastName=this.employeeData?.lastName
        //  this.passengerDetails.controls[0].value.dob=moment(this.employeeData?.dob).toISOString()||''
         this.passengerDetails.controls[0].value.gender=this.employeeData?.gender||''

         this.passengerDetails.controls[0].value.emailId=this.employeeData?.username
         this.passengerDetails.controls[0].value.contactNo=this.employeeData?.contactNumber
         this.passengerDetails.controls[0].value.profileType=this.employeeData?.profileType

         this.passengerDetails.controls[0].value.salutation=this.employeeData?.title
         this.passengerDetails.controls[0].value.username=this.employeeData?.username

         this.passengerDetails.controls[0].value.communicationAddress.addressLine1=this.employeeData?.address
         this.passengerDetails.controls[0].value.communicationAddress.state=this.employeeData?.state
         this.passengerDetails.controls[0].value.communicationAddress.pincode=this.employeeData?.pincode
         this.passengerDetails.controls[0].value.communicationAddress.cityDistrict=this.employeeData?.city
         this.passengerDetails.controls[0].value.communicationAddress.country=this.employeeData?.country

  
          let passportData=this.employeeData?.passportDetails.length > 0 ? this.employeeData?.passportDetails[this.employeeData?.passportDetails.length - 1] : null;
          // let visaData=this.employeeData?.visaDetails.length > 0 ? this.employeeData?.visaDetails[this.employeeData?.visaDetails.length - 1] : null;
          // console.log(passengerDetails.value.userPassportDetails)
          if(passportData){

          this.passengerDetails.controls[0].value.userPassportDetails.passportNo=passportData?.passportNumber
        }
          // console.log(passportData?.passportCountry)
          // VISA 

for(let i=0;i<this.passengerDetails.value.length;i++){

  this.passengerDetails.controls[i].value.username=this.employeeData?.username
  
}
this.passengerDetails.controls[0].value.reportingTags.forEach((item:any)=>{

  // console.log(item)
if(item.checkValue){
  if(this.employeeData.hasOwnProperty(item.checkValue)!=null){
    item.value=this.employeeData[item.checkValue] ?? ''
  }}

  
})

         this.passengerDetails.setValue(this.passengerDetails.value);


         this.userUid=this.employeeData?.userUid

         
         this.thirdFormGroup =this.fb.group({
          mobileCtrl: [this.employeeData?.contactNumber, [Validators.required,Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
          emailCtrl: [this.employeeData?.username, [Validators.required,Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
          address: [this.employeeData?.street, [Validators.required]],
          state: [this.employeeData?.state, [Validators.required]],
          pincode: [this.employeeData?.pincode, [Validators.required,Validators.pattern("^[0-9]+$")]],
          city: [this.employeeData?.city, [Validators.required]],
          country: [this.employeeData?.country, [Validators.required]],
        });

        if(this.employeeData.billingEntity){
          let entityData:any
          entityData=this.DataEntity.filter((entity:any)=>entity.entityRefId===this.employeeData.billingEntity)
          this.addBillingEntity(entityData[0]) 
        }else{
          if(this.DataEntity.length===1){
            this.addBillingEntity(this.DataEntity[0]) 

          }
        }
        


        // this.addBillingEntity()

        } else {    
          
        } 
      },error : (err) => {

        
      }
    }

  )

  }
  addTo(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.travellerName.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();

    this.traveller.setValue(null);
  }
  private _filter(value: any): any[] {
   // console.log(value)
    const filterValue = value.toLowerCase();
   
    return this.travellerTo.filter((item:any) => 
    item.username.toLowerCase().includes(filterValue)||
    item.firstName.toLowerCase().includes(filterValue)
    );
  }
 

  getrepriceData(response:any){
    let data:any=[]
    
    // this.totalCommercialAmount=this.flights?.commissionData?.finalAmount

    // this.commercialFee=this.getObjectKeysAndValues(this.flights?.commissionData)
    
   
    //  this.commercialFee=this.commercialFee.filter((item:any)=>item.key!='finalAmount')



    // console.log(this.flights?.flightDetailsList)
  



  
   



   
  
    this.initializeAdvancedPricingDataList()
//     this.flightArray.forEach((flightsItem:any,flightindex:number)=>{
//       // console.log(flightindex+1)
// this.travellerArray(this.travellerDetail.adult,flightsItem?.advancedPricingData?.advancedPricingList,'ADT')?.forEach((traveller:any,index:number)=>{

// this.SubmitAdvancePricings(traveller?.baseAmt, flightindex, 'ADT', 'baseAmt', index)
// this.SubmitAdvancePricings(traveller?.taxAmt, flightindex, 'ADT', 'taxAmt', index)
// this.SubmitAdvancePricings(traveller?.feeAmt, flightindex, 'ADT', 'feeAmt', index)
//       })
//       this.travellerArray(this.travellerDetail.child,flightsItem?.advancedPricingData?.advancedPricingList,'CHD')?.forEach((traveller:any,index:number)=>{
//         this.SubmitAdvancePricings(traveller?.baseAmt, flightindex, 'CHD', 'baseAmt', index+this.travellerDetail.adult)
//         this.SubmitAdvancePricings(traveller?.taxAmt, flightindex, 'CHD', 'taxAmt', index+this.travellerDetail.adult)
//         this.SubmitAdvancePricings(traveller?.feeAmt, flightindex, 'CHD', 'feeAmt', index+this.travellerDetail.adult)
//               })
//               this.travellerArray(this.travellerDetail.infantCount,flightsItem?.advancedPricingData?.advancedPricingList,'INF')?.forEach((traveller:any,index:number)=>{
                
//                 this.SubmitAdvancePricings(traveller?.baseAmt, flightindex, 'INF', 'baseAmt', index+this.travellerDetail.adult+this.travellerDetail.child)
//                 this.SubmitAdvancePricings(traveller?.taxAmt, flightindex, 'INF', 'taxAmt', index+this.travellerDetail.adult+this.travellerDetail.child)
//                 this.SubmitAdvancePricings(traveller?.feeAmt, flightindex, 'INF', 'feeAmt', index+this.travellerDetail.adult+this.travellerDetail.child)
//                       })
//     })
  
  this.swingGenerate=false
  this.onItineraryClick()

if(this.fetchPassengerDetails){
  if(this.fetchPassengerDetails.length>0){
    if(this.pnrNo){
      this.paymentDetail=true
      this.showSideBar=true
  let orderId={
    orderNumber:"",
    pnr:""
  }
  orderId.pnr=this.pnrNo
  orderId.orderNumber=response.orderId
      this.order.deliverMsg(orderId)
  this.swingGenerate=false
     }else{

      let json:any = sessionStorage.getItem('json');
      this.advanceTotal =Number(sessionStorage.getItem('advancetotal'));
      // this.totalSeatPrice =Number(sessionStorage.getItem('totalSeatPrice'));
      // this.totalMealPrice =Number(sessionStorage.getItem('totalMealPrice'));

      // this.totalspecialSsrPrice =Number(sessionStorage.getItem('totalspecialSsrPrice'));
      // this.totalssrBaggagePrice =Number(sessionStorage.getItem('totalssrBaggagePrice'));
     
      // console.log(response?.billingEntity)
       this.billingDetail.entityRefId=response?.billingEntity
this.OrderId(JSON.parse(json))
 
  // this.paymentDetail=true
  this.swingGenerate=false

}
 }}
  }
  hideAdvancePricing:boolean=true
  flightArray:any=[]
  orderId:any
swingGenerate:boolean=false
swingOrderId:boolean=false

  // generateOrder(data:any){

  //   if(this.returnFlights){
  //     data.bookingRequest.selectedFlight[0].source=this.flights?.source
  //     data.bookingRequest.selectedFlight[1].source=this.returnFlights?.source

  //   }else{
  //     data.bookingRequest.selectedFlight[0].source=this.flights?.source

  //   }
  //   this.FlightService
  //   .generateOrder(data)
  //   .subscribe({
  //     next : (res:any) => {
  //       this.swingGenerate=false

  //       if(res) {
  //         console.log(data)
  //         this.repriceData=data?.bookingRequest?.selectedFlight
  //        let item:any
  //        item=res  
  //        this.orderId=item
        
  //       

  //       } else {    
  //       } 
  //     },error : (err) => {

       

  //     }
  //   }
  // )
  // }
  orderboolean:any
  OrderId(item:any){
    this.swingOrderId=true

    this.InsuranceService
    .OrderId(this.orderId,item)
    .subscribe({
      next : (res:any) => {
        this.swingOrderId=false
        if(res) {
         let data:any
         data=res  
         this.orderboolean=true
         this.paymentDetail=true
         console.log('order')
         data.entityRefId=this.billingDetail?.entityRefId
         this.hideAdvancePricing=false
data.request=item
         this.order.deliverMsg(data)

        } else {    
        } 
      },error : (err) => {

        this.swingOrderId=false

      }
    }
  )
  
  }
  
  expandedPanel: string | null = null;
  
  togglePanel(panel: string): void {
    this.expandedPanel = this.expandedPanel === panel ? null : panel;
  }


  getObjectKeysAndValues(obj: any): { key: string, value: any }[] {
    // console.log(this.departureFlight)
    // let flight:any=this.departureFlight
   
    if(obj){
  

      let object:any=[]
       object=Object.entries(obj).map(([key, value]) => ({ key, value }));
       let hiddenKeys: any="bookingAmount,currency"
    object=object.filter((item:any)=>!hiddenKeys.includes(item.key))

   
    return object;
   }else{
    return obj
   }
  }

  changeKey(item:any){
    if(item==='totalAmount'){
      let traveller=(Number(this.travellerDetail?.adult)+Number(this.travellerDetail?.child)+Number(this.travellerDetail?.infantCount))
      if(traveller>1){
        item="Base fare ("+traveller+" travellers)"

      }else if(item==="airlineTaxes"){
        item="Taxes and fees"


      }
     else{
        item="Base fare ("+traveller+" traveller)"

      }
      return item
    }else{
    return  item
    }
  }
  showSideBar:boolean=false
  hideSideBar(){
   this.showSideBar=true
  }

  rulesPriv(){

    this.FlightService
    .rules()
    .subscribe({
      next : (res:any) => {
        if(res) {
          let data:any
         data=res
          this.rules.InputPaxInfo=data.InputPaxInfo
        } else {    
        } 
      },error : (err) => {


      }
    }
  )
  
  }
 
  flightlogoFilter(item:any){
  
    if(item){
       let flightName:any=[]
    flightName=this.carrierCode.filter((itm: { carrierCode: any; })=>itm.carrierCode === item)
    
    if(flightName.length===0){
     return item
   
   }else{
     flightName =flightName[0]?.logo
     return flightName
   }
    }else{return item}
   }
page:any={
  page:0
}
   totalElements:number=0
   nextPage(event:PageEvent) {
   
    this.page['page'] = event.pageIndex.toString();
    // page['size'] = event.pageSize.toString();
    this.flightSeatMapping=this.flights?.flightDetailsList[this.page.page]
  //  this.openSeat()
  
  }

  DataEntity:any=[]
  focusSearch(isOpen: boolean, searchInput: HTMLInputElement) {
    this.filterEntities()
    if (isOpen) {
      setTimeout(() => {
        searchInput.focus(); // Focus the input when the mat-select opens
      });
    }
  }
  dataEntitylist(){

    this.DataEntityService
   .listEntities(this.userUuid)
   .subscribe({
      next : (res:any) => {
        if(res) {
       let data=res?.filter((item:any)=>item.isEnabled===true)


       this.DataEntity=data
      this.filterEntities()
        } else {
       
        } 
      },error : (err) => {

    }
    }
  )
 }
 reportingData:any=[]
 reportingTags(){

  this.DataEntityService
 .tagPAX(this.userUuid)
 .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.reportingData=data['body']
      } else {
     
      } 
    },error : (err) => {

  }
  }
)
}
billingDetail:any={
  entityRefId:''
}
 addBillingEntity(item:any){

  
this.billingDetail=item

this.secondFormGroup.patchValue({
  BillingEntity: this.billingDetail?.entityName
});
this.searchQuery=''
this.filterEntities()

 }
 @ViewChild('tabsRef') tabsRef!: ElementRef;

 tabs = [
  { name: 'Tab 1', active: true },
  { name: 'Tab 2', active: false },
  { name: 'Tab 3', active: false },
  { name: 'Tab 4', active: false },
  { name: 'Tab 5', active: false },
  { name: 'Tab 6', active: false },
  { name: 'Tab 7', active: false },
  { name: 'Tab 8', active: false },
  { name: 'Tab 9', active: false },
  { name: 'Tab 10', active: false }
];
 scrollTabs(direction: 'left' | 'right') {
  const tabsContainer = this.tabsRef.nativeElement;
  const scrollAmount = 200;
  if (direction === 'left') {
    tabsContainer.scrollBy({
      left: -scrollAmount,
      behavior: 'smooth'
    });
  } else if (direction === 'right') {
    tabsContainer.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });
  }
}


fetchMeal(item:any,source:any){

  let request:any={}
  request['carrierCode']=item?.carrierName
  request['equipmentType']=item?.equipmentType
  request['travelType']='D'
  request['source']=source
this.FlightService
  .getMeal(request)
  .subscribe({
    next : (res:any) => {
      if(res) {
        let data:any
        data=res?.body
        
       item.tag=data

      
      } else {  
      } 
    },error : (err) => {


    }
  }
)

}
showSeatSelection:boolean=false
flightItem:any
flightType:any
flightIndex:any
seatWindow(flightDetailsList:any,flight:any,item:any,flightType:any,index:any){
  this.flightIndex=index
this.flightType=flightType
  this.flightItem=item
  this.totalElements=this.flights?.flightDetailsList?.length
  this.flightSeatMapping=flightDetailsList
  flightDetailsList.showSeatSelection=true
  this.seats=[]



  this.openSeat(flightDetailsList,flight)
  this.selectedSeats=[]
}
openSeat(flightDetailsList:any,flight:any){
  this.seats=[]

  let data:any=[]

 
    for(let i=0;i<flight.flightDetailsList.length;i++){
     
     
      
    flight.flightDetailsList[i].bookingClasses=flight.flightDetailsList[i].bookingClasses.filter((item:any)=>item.fareType===flight.fare[0].fareType&&item?.corporateFare === flight.fare[0].corporateFare)
  }
    data={
      
      "paxCount": this.travellerDetail?.adult+this.travellerDetail?.child+this.travellerDetail?.infantCount,
      "adultCount": this.travellerDetail?.adult,
      "childCount": this.travellerDetail?.child,
      "infantCount": this.travellerDetail?.infantCount,
      "selectedFlight": [
            {
              "otherData":flight?.otherData,
               "routeRequest":flight?.routeRequest,
                "source":flight?.routeRequest?.source,
                "fromAirport": flight.flightDetailsList[this.flightIndex].fromAirport,
                // "toAirport":  flight.flightDetailsList[flight.flightDetailsList.length - 1].toAirport,
                "toAirport":  flight.flightDetailsList[this.flightIndex].toAirport,

                "flightDetailsList": [flightDetailsList]
  
            }
        ],
    
    } 
  
  
  
  this.seatMapping(data,flightDetailsList)
}
seatPopup:boolean=false
closePopup(){
  this.seatPopup=false
}
showSidebar:boolean=false

travellerArray(item:any,data:any,passengerType:any){

  let traveller=[]
  if(item){
   

  for(let i=0;i<item;i++){
    traveller.push(this.changeAdvancedPricing(data,passengerType)[0])

  }
  
  // for(let item of traveller){
  //   this.advanceTotal+=Number(item.baseAmt)+Number(item.feeAmt)+Number(item.taxAmt)

  // }
}

   
  return traveller
}
onlyNumberKey(event:any) {
     
  let charCode = (event.which) ? event.which : event.keyCode;
  if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
  return true;
}


advancedPricingDataList:any=[]
advanceTotal:number=0
// SubmitAdvancePricing(item:any){
  
// this.total+=Number((item.target as HTMLInputElement).value)
// }
initializeAdvancedPricingDataList() {
  this.advancedPricingDataList = this.dataMapping?.insurancePlanSearchResponse?.persons.map((item:any) =>  item.commercial );
console.log(this.advancedPricingDataList )
 
  // this.dataMapping?.insurancePlanSearchResponse?.persons.forEach((item:any) => {
  //   this.advancedPricingDataList.push(item.commercial);
    
  // });
}



SubmitAdvancePricing(event: Event, index: number) {
// console.log(event)



  let value:any = (event.target as HTMLInputElement).value;
  // let value:any = event

  const pricingData = this.advancedPricingDataList;

  if (!pricingData[index]) {
    pricingData[index] = { markup: 0};
  }
  console.log( parseFloat(value||0))
  pricingData[index].markup = parseFloat(value||0);
// console.log(pricingData)

  this.advanceTotal=0
  this.advancedPricingDataList.forEach((item:any)=>{
      
    this.advanceTotal+=Number(item.markup||0)

  
})
  

}

SubmitAdvancePricings(event: any, flightsItemIndex: number, passengerType: string, field: string, index: number) {
    let value:any = event
    // let value:any = event

    const pricingData = this.advancedPricingDataList[flightsItemIndex].advancedPricingList;
    // console.log(pricingData)

    if (!pricingData[index]) {
      pricingData[index] = { passengerType, feeAmt: 0, baseAmt: 0, taxAmt: 0 };
    }
  pricingData[index][field] = parseFloat(value||0);
  
  
    this.advanceTotal=0
    this.advancedPricingDataList.forEach((item:any)=>{
      item.advancedPricingList.forEach((price:any)=>{
        
        this.advanceTotal+=Number(price.baseAmt)+Number(price.feeAmt)+Number(price.taxAmt)
  
      })
    })
    
  }
submit(){
  this.showSidebar=false
  
}
OnSidebarClick(){
  this.initializeAdvancedPricingDataList()

  this.showSidebar=true
}


value(item:any){
  // console.log(item)
//  return item.value.value
}
mealData:any
showSpiner:boolean=false

onClickMeal(flightDetailsList:any,flight:any){
  // console.log(flightDetailsList)
  this.showSpiner=true
  this.mealData=[]
  let data:any=[]

 
  //   for(let i=0;i<flight.flightDetailsList.length;i++){
     
     
      
  //   flight.flightDetailsList[i].bookingClasses=flight.flightDetailsList[i].bookingClasses.filter((item:any)=>item.fareType===flight.fare[0].fareType&&item?.corporateFare === flight.fare[0].corporateFare)
  // }
    data={
      
      "paxCount": this.travellerDetail?.adult+this.travellerDetail?.child+this.travellerDetail?.infantCount,
      "adultCount": this.travellerDetail?.adult,
      "childCount": this.travellerDetail?.child,
      "infantCount": this.travellerDetail?.infantCount,
      "selectedFlight": [
            {
              "otherData":flight?.otherData,
               "routeRequest":flight?.routeRequest,
                "source":flight?.routeRequest?.source,
                "fromAirport":flightDetailsList.fromAirport,
                "toAirport":  flightDetailsList.toAirport,
                "flightDetailsList": [flightDetailsList]
  
            }
        ],
    
    } 
    this.FlightService
    .mealMapping(data,this.orderId)
    .subscribe({
      next : (res:any) => {
        this.showSpiner=false

        this.swingOrderId=false
        if(res) {
         let detail:any
         detail=res  
         flightDetailsList.mealData=detail.ssrMeals

        } else {    
        } 
      },error : (err) => {
        this.showSpiner=false

        this.toastMsgService.setMsg({msg : "Meal is not available",msgTitle : "Warning", msgType : "W"});


      }
    }
  )
  
  
    
}

onClickBaggage(flightDetailsList:any,flight:any){
  this.showSpiner=true
  // this.mealData=[]
  let data:any=[]

 
  //   for(let i=0;i<flight.flightDetailsList.length;i++){
     
     
      
  //   flight.flightDetailsList[i].bookingClasses=flight.flightDetailsList[i].bookingClasses.filter((item:any)=>item.fareType===flight.fare[0].fareType&&item?.corporateFare === flight.fare[0].corporateFare)
  // }
    data={
      
      "paxCount": this.travellerDetail?.adult+this.travellerDetail?.child+this.travellerDetail?.infantCount,
      "adultCount": this.travellerDetail?.adult,
      "childCount": this.travellerDetail?.child,
      "infantCount": this.travellerDetail?.infantCount,
      "selectedFlight": [
            {
              "otherData":flight?.otherData,
               "routeRequest":flight?.routeRequest,
                "source":flight?.routeRequest?.source,
                "fromAirport": flightDetailsList?.fromAirport,
                "toAirport":  flightDetailsList?.toAirport,
                "flightDetailsList": [flightDetailsList]
  
            }
        ],
    
    } 
    this.FlightService
    .mealMapping(data,this.orderId)
    .subscribe({
      next : (res:any) => {
        this.showSpiner=false

        this.swingOrderId=false
        if(res) {
         let detail:any
         detail=res  
         flightDetailsList.ssrBaggageData=detail.ssrBaggage

        } else {    
        } 
      },error : (err) => {
        this.showSpiner=false

        this.toastMsgService.setMsg({msg : "Baggage is not available",msgTitle : "Warning", msgType : "W"});


      }
    }
  )
  
  
    
}


onClickSpecial(flightDetailsList:any,flight:any){
  this.showSpiner=true
  // this.mealData=[]
  let data:any=[]

 
  //   for(let i=0;i<flight.flightDetailsList.length;i++){
     
     
      
  //   flight.flightDetailsList[i].bookingClasses=flight.flightDetailsList[i].bookingClasses.filter((item:any)=>item.fareType===flight.fare[0].fareType&&item?.corporateFare === flight.fare[0].corporateFare)
  // }
    data={
      
      "paxCount": this.travellerDetail?.adult+this.travellerDetail?.child+this.travellerDetail?.infantCount,
      "adultCount": this.travellerDetail?.adult,
      "childCount": this.travellerDetail?.child,
      "infantCount": this.travellerDetail?.infantCount,
      "selectedFlight": [
            {
              "otherData":flight?.otherData,
               "routeRequest":flight?.routeRequest,
                "source":flight?.routeRequest?.source,
                "fromAirport": flightDetailsList.fromAirport,
                "toAirport":  flightDetailsList.toAirport,
                "flightDetailsList": [flightDetailsList]
  
            }
        ],
    
    } 
    this.FlightService
    .mealMapping(data,this.orderId)
    .subscribe({
      next : (res:any) => {
        this.showSpiner=false

        this.swingOrderId=false
        if(res) {
         let detail:any
         detail=res
         flightDetailsList.specialSsrData=detail.ssrSpecial

        } else {    
        } 
      },error : (err) => {
        this.showSpiner=false

        this.toastMsgService.setMsg({msg : "Special SSR is not available",msgTitle : "Warning", msgType : "W"});


      }
    }
  )
  
  
    
}


changeAdvancedPricing(item:any,passengerType:any)
{
  // console.log(item.filter((item:any)=>item.passengerType===passengerType))

return item.filter((items:any)=>items.passengerType===passengerType)
}


revertStringToData(dataString: string): any[] {
  if(dataString){
  return dataString.split('&').map(item => {
    const [Program, number, boolean] = item.split('$');
    return { Program, number, boolean: boolean === 'true' };
  });}else{
    return []
  }
}
totalspecialSsrPrice:any=0
totalssrBaggagePrice:any=0
totalSeatPrice:any=0
totalMealPrice:any=0
mealSeatPriceTotal(){
 let totalSeatPrice:any=0
 let totalMealPrice:any=0
 let totalssrBaggagePrice:any=0
 let totalspecialSsrPrice:any=0


  for(let j=0 ;j<this.flightMealDetails.length;j++){
    // console.log("4")
    let flight:any=[]
  
    if(this.returnFlights&&!this.thirdFlights&&!this.fourthFlights){
      flight=flight.concat(this.flightMealDetails[j].flight.flightDetailsList,this.flightMealDetails[j].returnFlights.flightDetailsList)
  }else if(this.thirdFlights&&!this.fourthFlights){
    flight=flight.concat(this.flightMealDetails[j].flight.flightDetailsList,this.flightMealDetails[j].returnFlights.flightDetailsList,this.flightMealDetails[j].thirdFlights.flightDetailsList)
  
  }else if(this.fourthFlights){
    flight=flight.concat(this.flightMealDetails[j].flight.flightDetailsList,this.flightMealDetails[j].returnFlights.flightDetailsList,this.flightMealDetails[j].thirdFlights.flightDetailsList,this.flightMealDetails[j].fourthFlights.flightDetailsList)
  
  }
  else{
      flight=this.flightMealDetails[j].flight.flightDetailsList
  
    }
    console.log(flight)
    flight.forEach((it:any)=>{

      if("seatPrice" in it){
      totalSeatPrice+=Number(it?.seatPrice||0)}
      if("meal" in it){
        totalMealPrice+=Number(it?.meal?.baseFare||0)}
        if("ssrBaggage" in it){
          totalssrBaggagePrice+=Number(it?.ssrBaggage?.baseFare||0)}
          if("specialSsr" in it){
            totalspecialSsrPrice+=Number(it?.specialSsr?.baseFare||0)}

    })
   

  }
  this.totalMealPrice=totalMealPrice
  this.totalSeatPrice=totalSeatPrice
  this.totalspecialSsrPrice= totalspecialSsrPrice
  this.totalssrBaggagePrice=totalssrBaggagePrice
}
tagDropDown(value:any){
  return value.split('|')
}

onFileChange(event: any, index: number,con:AbstractControl) {
  const file = event.target.files[0];
  if (file) {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      // this.getReportingTagsControls()

      const formArray = con.get('reportingTags') as FormArray;
      console.log()
      formArray.value[index].value=reader.result
        // formArray.at(index).patchValue({
        //   value: reader.result
        // });

      };
    reader.onerror = (error) => {
      console.error('Error reading file:', error);
    };
  }
}


searchQuery: any = '';

filteredEntities: any[] = [...this.DataEntity]; // Clone the original data

// Function to filter the entities based on the search query
filterEntities() {

  this.filteredEntities = this.DataEntity.filter((item:any) =>
    item.entityName.toLowerCase().trim().includes(this.searchQuery.toLowerCase().trim())
  );

  
}


tripEnable:boolean=false
ENABLE_TRIP_MGMT(){

    this.UserService.ENABLE_TRIP_MGMT()
    .subscribe({
      next : (res:any) => {
        if(res) {
       if(res.policyType==='TRIP_MGMT'){
        if(res.rule==='1'){
this.tripEnable=true
        }else 
        if(res.rule==='2'){
          this.tripEnable=true
                    }else{
          this.tripEnable=false

        }

       }
 
      }else{

      }},error : (err) => {
  
        console.error("Error in fetching data");
      }
    }
  )
  
}
// Your existing addBillingEntity function


onDateChange(event: any, index: number,item:any) {
  const selectedDate = event.value; // Get the selected date
  if (selectedDate) {
    const formattedDate = this.formatDate(selectedDate);
    this.passengerDetails.controls[index].get(item)?.setValue(formattedDate);
    // console.log(this.passengerDetails.controls[index].get(item)?.setValue(formattedDate))

  }
}
onDateCChange(event: any, index: number,item:any) {
  const selectedDate = event.value; // Get the selected date
  if (selectedDate) {
    const formattedDate = this.formatDate(selectedDate);
    this.passengerChild.controls[index].get(item)?.setValue(formattedDate);
  }
}
onDateIChange(event: any, index: number,item:any) {
  const selectedDate = event.value; // Get the selected date
  if (selectedDate) {
    const formattedDate = this.formatDate(selectedDate);
    this.passengerInfent.controls[index].get(item)?.setValue(formattedDate);
  }
}

// Function to format date as "YYYY-MM-DD"
formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure two digits
  const day = String(date.getDate()).padStart(2, '0'); // Ensure two digits
  return `${year}-${month}-${day}`;
}
isFirstOccurrence(item: any, index: number,con:any): boolean {
  return con.flightDetailsList.findIndex((f:any) =>f.flightNumber === item.flightNumber &&f.carrierName === item.carrierName) === index;
}






calculateTotalPriceBreakup(data: any[]) {
  let totalBasePrice = 0;
  let totalTax = 0;
  let totalFee = 0;
  let totalGst = 0;

  data.forEach(item => {
    totalBasePrice += item.insuranceBasePrice + item.commercial.totalMarkup;
    totalTax += item.insuranceTax;
    totalFee += item.commercial.charge;
    totalGst += item.commercial.tax;
  });

  const totalPrice = totalBasePrice + totalTax + totalFee + totalGst;

  return {
    totalBasePrice: Number(totalBasePrice.toFixed(2)),
    tax: Number(totalTax.toFixed(2)),
    fee: Number(totalFee.toFixed(2)),
    gst: Number(totalGst.toFixed(2)),
    totalPrice: Number(totalPrice.toFixed(2))
  };
}



countryList:any=[]
countryListByCategory(){

  this.InsuranceService.countryList()
  .subscribe({
    next : (res:any) => {
      if(res) {
  let data:any=res.body
  data=data.filter((item:any)=>item.geography===this.dataMapping?.insuranceRequest?.geography)
this.countryList=data
    }else{

    }},error : (err) => {

      console.error("Error in fetching data");
    }
  }
)

}

onDateDobChange(event: any, index: number): void {
  const selected = event.value;
  if (selected) {
    const formattedDate = `${selected.getFullYear()}-${String(selected.getMonth() + 1).padStart(2, '0')}-${String(selected.getDate()).padStart(2, '0')}`;
    this.passengerDetails.at(index).get('nomineeDob')?.setValue(formattedDate);
  }
}
}
